import {
  Component,
  OnDestroy,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { AuthenticationService } from '../shared/services/authentication/authentication.service';
import { Router, RouterLink } from '@angular/router';
import { isEmptyOrUndefined } from '@ui/global-shared/util/string-util';
import { catchError, switchMap } from 'rxjs/operators';
import { EMPTY, from, Subscription } from 'rxjs';
import { TopBannerComponent } from '../layout/top-banner/top-banner.component';
import { FormsModule } from '@angular/forms';
import { FormLabelComponent } from '@ui/global-shared/components/form-label/form-label.component';
import { Bind } from 'primeng/bind';
import { InputText } from 'primeng/inputtext';
import { CustomFormErrorsComponent } from '@ui/global-shared/components/custom-form-errors/custom-form-errors.component';
import { Button } from 'primeng/button';
import { B2bFooterComponent } from '@ui/global-shared/components/b2b-footer/b2b-footer.component';

@Component({
  selector: 'pt-login-landing',
  templateUrl: './login-landing.component.html',
  styleUrls: ['./login-landing.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TopBannerComponent,
    RouterLink,
    FormsModule,
    FormLabelComponent,
    Bind,
    InputText,
    CustomFormErrorsComponent,
    Button,
    B2bFooterComponent,
  ],
})
export class LoginLandingComponent implements OnDestroy {
  private authenticationService = inject(AuthenticationService);
  private router = inject(Router);

  username: string;
  password: string;

  invalidCredentials = false;
  private subscriptions$ = new Subscription();

  authenticateUser(): void {
    if (
      isEmptyOrUndefined(this.username) ||
      isEmptyOrUndefined(this.password)
    ) {
      this.invalidCredentials = true;
      return;
    }

    this.subscriptions$.add(
      this.authenticationService
        .authenticateUser(this.username, this.password)
        .pipe(
          switchMap((success) => {
            if (!success) {
              this.invalidCredentials = true;
              return EMPTY;
            }
            return from(this.router.navigate(['supplier-area']));
          }),
          catchError(() => {
            this.invalidCredentials = true;
            return EMPTY;
          }),
        )
        .subscribe(),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions$.unsubscribe();
  }
}
